class AdrollAnalytics {
  clientSales(campaign) {
    this._triggerHelper(campaign.pixels.campaign, campaign.pixels.global)
  }

  clientThankYou(order) {
    this._triggerHelper(order.campaign.pixels.campaign, order.campaign.pixels.global)
  }

  _triggerHelper(campaignPixels, globalPixels) {
    this._trigger(campaignPixels);

    if (campaignPixels.adroll.pixel_id !== globalPixels.adroll.pixel_id && campaignPixels.adroll.adv_id !== globalPixels.adroll.adv_id) {
      this._trigger(globalPixels);
    }
  }

  _trigger(pixels) {
    if (pixels.adroll.pixel_id && pixels.adroll.adv_id) {
      window.dataLayer.push({ clientAdrollAdvId: pixels.adroll.adv_id }, { clientAdrollPixelId: pixels.adroll.pixel_id }, { event: 'client-adroll-tracking' });
    }
  }
}

export default new AdrollAnalytics();


// WEBPACK FOOTER //
// ./source/client/analytics/adroll.js